// Genera una tarjeta-resumen 1080x1350 del jugador tras el partido (canvas → blob).
import { POSITION_LABEL } from "@/components/familia/PositionPicker";

export async function buildShareCard({ playerName, dorsal, titular, valoracion, tg, tr, posicion, result, opponent, homeAway, date, stats, season }) {
  const W = 1080, H = 1350;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  ctx.fillStyle = "#0a0a0a";
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#dc2626";
  ctx.fillRect(0, 0, W, 14);
  ctx.globalAlpha = 0.08;
  ctx.beginPath();
  ctx.moveTo(W, H); ctx.lineTo(W - 560, H); ctx.lineTo(W, H - 560);
  ctx.fill();
  ctx.globalAlpha = 1;

  ctx.fillStyle = "#dc2626";
  ctx.font = "900 32px Arial";
  ctx.letterSpacing = "8px";
  ctx.fillText("SUDEFOOTBALL PLAYER", 70, 95);
  ctx.letterSpacing = "0px";

  ctx.fillStyle = "#ffffff";
  ctx.font = "900 84px Arial";
  const name = playerName.toUpperCase();
  ctx.fillText(name.length > 18 ? name.slice(0, 18) + "…" : name, 70, 195);

  // Línea meta: dorsal · titular/suplente · tarjetas
  const meta = [];
  if (dorsal) meta.push(`#${dorsal}`);
  if (titular !== undefined && titular !== null) meta.push(titular ? "TITULAR" : "SUPLENTE");
  if (posicion) meta.push((POSITION_LABEL[posicion] || posicion).toUpperCase());
  if (tg) meta.push(`🟨${tg > 1 ? `x${tg}` : ""}`);
  if (tr) meta.push(`🟥${tr > 1 ? `x${tr}` : ""}`);
  if (meta.length) {
    ctx.fillStyle = "#dc2626";
    ctx.font = "900 42px Arial";
    ctx.fillText(meta.join("  ·  "), 70, 262);
  }

  const res = result.gf > result.gc ? "VICTORIA" : result.gf === result.gc ? "EMPATE" : "DERROTA";
  ctx.fillStyle = res === "VICTORIA" ? "#10b981" : res === "EMPATE" ? "#f59e0b" : "#94a3b8";
  ctx.font = "900 40px Arial";
  ctx.fillText(res, 70, 360);
  ctx.fillStyle = "#ffffff";
  ctx.font = "900 104px Arial";
  ctx.fillText(`${result.gf} - ${result.gc}`, 70, 465);
  ctx.fillStyle = "#a1a1aa";
  ctx.font = "600 38px Arial";
  const opp = `vs ${opponent}`.toUpperCase();
  ctx.fillText(opp.length > 32 ? opp.slice(0, 32) + "…" : opp, 70, 528);
  ctx.fillText(`${date} · ${homeAway === "casa" ? "EN CASA" : "FUERA"}`, 70, 580);

  // Valoración familiar (estrellas)
  if (valoracion) {
    ctx.fillStyle = "#f59e0b";
    ctx.font = "900 46px Arial";
    ctx.fillText("★".repeat(valoracion) + "☆".repeat(5 - valoracion), 70, 645);
    ctx.fillStyle = "#71717a";
    ctx.font = "700 26px Arial";
    ctx.fillText("VALORACIÓN DEL PARTIDO", 320, 640);
  }

  // Grid de estadísticas (3 columnas, hasta 12 celdas)
  const core = [
    ["MINUTOS", stats.min ?? 0], ["GOLES", stats.gols ?? 0],
    ["ASISTENCIAS", stats.asist ?? 0], ["REMATES", stats.remates ?? 0],
  ];
  const opt = [
    ["PASES ✓", stats.pases], ["PASES CLAVE", stats.claves], ["PÉRDIDAS", stats.perdidas],
    ["RECUPERAC.", stats.recup], ["REGATES", stats.regates], ["DUELOS ⚔", stats.duelos],
    ["JUEGO AÉREO", stats.aereos], ["INTERCEPC.", stats.interc], ["ENTRADAS", stats.entradas], ["CENTROS", stats.centros],
  ].filter(([, v]) => Number(v) > 0);
  const all = [...core, ...opt].slice(0, 12);
  const cols = 3, gap = 16, cw = (W - 140 - gap * (cols - 1)) / cols, ch = 112, rowGap = 14;
  all.forEach(([label, val], i) => {
    const x = 70 + (i % cols) * (cw + gap);
    const y = 690 + Math.floor(i / cols) * (ch + rowGap);
    ctx.strokeStyle = "#27272a";
    ctx.lineWidth = 3;
    ctx.strokeRect(x, y, cw, ch);
    ctx.fillStyle = "#dc2626";
    ctx.font = "900 22px Arial";
    ctx.fillText(label, x + 22, y + 38);
    ctx.fillStyle = "#ffffff";
    ctx.font = "900 54px Arial";
    ctx.fillText(String(val), x + 22, y + 94);
  });

  // Totales de temporada
  if (season && season.pj > 0) {
    const yS = 690 + Math.ceil(all.length / cols) * (ch + rowGap) + 42;
    ctx.fillStyle = "#dc2626";
    ctx.font = "900 26px Arial";
    ctx.fillText("TEMPORADA", 70, yS);
    ctx.fillStyle = "#e4e4e7";
    ctx.font = "700 34px Arial";
    ctx.fillText(`${season.pj} PJ  ·  ${season.gol} GOLES  ·  ${season.asi} ASIST.  ·  ${season.min} MIN`, 70, yS + 46);
  }

  ctx.fillStyle = "#52525b";
  ctx.font = "600 28px Arial";
  ctx.fillText("Sigue su evolución en app.sudefootball.sudeporte.com/player", 70, H - 50);

  return new Promise((resolve) => c.toBlob(resolve, "image/png"));
}

export async function shareCard(blob, playerName) {
  const file = new File([blob], `partido-${playerName.split(" ")[0].toLowerCase()}.png`, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: `Partido de ${playerName}` });
      return "shared";
    } catch { return "cancelled"; }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = file.name; a.click();
  URL.revokeObjectURL(url);
  return "downloaded";
}
